module.exports = __webpack_public_path__ + "static/media/state-props-blue.f68bec35.png";